import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`The European Commission’s Directorate-General for International Cooperation and Development (DEVCO) is a key WFP partner in finding long-term solutions to tackle the main drivers of hunger. Its support has enabled WFP and other organisations to produce the `}<a parentName="strong" {...{
          "href": "https://www.wfp.org/publications/2020-global-report-food-crises"
        }}>{`Global Report on Food Crises`}</a>{`, which provides the latest estimates of acute hunger in the world. The report is the flagship product of the Global Network Against Food Crises, launched in 2016 by the European Union, WFP and FAO to prevent and address the most severe hunger emergencies.`}</strong></p>
    <p>{`The latest edition of the report found that in 2019, 135 million people in 55 countries experienced acute food insecurity – this is when a person’s inability to consume adequate food puts their lives or livelihoods in immediate danger. Additionally, 75 million children were stunted and 17 million suffered from wasting. This is the highest level of food insecurity and malnutrition that has been documented by the Network since the first report released in 2017. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      